function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { useMemo } from 'react';

var MenuPanelBottom = function MenuPanelBottom(_ref) {
  var menu = _ref.menu,
      hide = _ref.hide;
  var defaultBottomData = useMemo(function () {
    var activeBlock = menu.blocks.find(function (block) {
      return block.id === menu.activeBlock;
    });
    return activeBlock.bottom;
  }, []);

  if (!defaultBottomData) {
    return null;
  }

  var bottomMenuItems = defaultBottomData.items.map(function (menuItem) {
    return /*#__PURE__*/React.createElement("li", {
      className: "menu-panel-section bg-light",
      key: menuItem.label
    }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
      className: "menu-panel-link container container-lg-fluid",
      onClick: function onClick() {
        hide();
      }
    })));
  });
  return /*#__PURE__*/React.createElement("ul", {
    className: "list-unstyled mb-0"
  }, bottomMenuItems);
};

export { MenuPanelBottom };